<template>
  <div class="wrapper">
    <div class="container-fluid">
      <div
        class="row d-flex flex-row justify-content-between background py-3 px-3"
      >
        <a href="/">
          <img
            src="https://www.lokpath.com/wp-content/themes/newlokpath/img/newlogo.png"
            class="img-fluid"
            width="350"
          />
        </a>

        <div class="heading text display-4 font-weight-bold">
          <!-- लोकपथ फन्ट कनभर्टर -->
        </div>
      </div>
    </div>

    <nav class="navbar navbar-expand-lg navbar-dark static-top">
      <div class="container-fluid">
        <a class="navbar-brand" href="#">
          <i class="fa fa-home text-white" aria-hidden="true"></i>
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
          ref="navbar"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link" href="/">
                Home
                <span class="sr-only">(current)</span>
              </a>
            </li>

            <li class="nav-item">
              <router-link class="nav-link" to="/preeti-to-unicode"
                >Preeti to Unicode</router-link
              >
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/unicode-to-preeti"
                >Unicode to Preeti</router-link
              >
            </li>

            <li class="nav-item">
              <a class="nav-link" target="_blank" href="https://lokpath.com"
                >News Portal</a
              >
            </li>
            <li class="nav-item">
              <div class="d-flex social">
                <a
                  class="nav-link"
                  target="_blank"
                  href="https://www.facebook.com/lokpath"
                >
                  <i class="fab fa-facebook text-white" aria-hidden="true"></i>
                </a>
                <a
                  class="nav-link"
                  target="_blank"
                  href="https://twitter.com/lokpath"
                >
                  <i class="fab fa-twitter text-white" aria-hidden="true"></i>
                </a>
                <a
                  class="nav-link"
                  target="_blank"
                  href="https://www.instagram.com/lokpath/"
                >
                  <i class="fab fa-instagram text-white" aria-hidden="true"></i>
                </a>
                <a
                  class="nav-link"
                  target="_blank"
                  href="https://www.youtube.com/channel/UCIU5kk4fkGlbZs58FKcZEYA"
                >
                  <i class="fab fa-youtube text-white" aria-hidden="true"></i>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    watch: {
      $route() {
        var navbar = document.querySelector("#navbarResponsive");
        console.log(navbar);
        //   var navbar=
        if (navbar.classList.contains("show")) {
          navbar.classList.remove("show");
        }
        // this.$refs.navbar.click(); //("hide");
      },
    },
  };
</script>

<style scoped>
  .background {
    background-color: #a7363922;
  }
  .social a {
    margin: 0px 10px;
  }
  .router-link-exact-active {
    font-weight: 700;
    color: #fff !important;
    background-color: #f001;
  }
</style>
